"use client";

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface SubscriptionConfirmDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  action: "expire" | "activate" | null;
  onConfirm: () => void;
}

export function SubscriptionConfirmDialog({
  open,
  onOpenChange,
  action,
  onConfirm,
}: SubscriptionConfirmDialogProps) {
  const getDescription = () => {
    if (action === "expire") {
      return "This will expire the subscription immediately. Future appointments will not be cancelled and can still be used when the subscription is activated again.";
    }
    if (action === "activate") {
      return "This will activate the subscription. No new billing cycle, no new payment, and no new appointments will be created. The original start date is preserved.";
    }
    return "";
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Are you sure?</AlertDialogTitle>
          <AlertDialogDescription>{getDescription()}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>
            {action === "expire" ? "Expire Subscription" : action === "activate" ? "Activate Subscription" : "Confirm"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

